import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import axios from 'axios';
import { useCustomSnackbar } from '../hooks/useCustomSneakbar';
import moment from 'moment';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import { Loader } from '../components/ModalsCommonFunctions';

const TopicMaster = () => {
    const authorizedAxios = generateAxiosInstance()
    const initialFormState = {
        syllabusStructureMasterId: '',
        lessonMasterId: '',
        topicName: [''],
        subjectMasterId: ''
    }
    const [syllabusList, setSyllabusList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [topicData, setTopicData] = useState(initialFormState)
    const [editId, setEditId] = useState(null)
    const [subjectList, setSubjectList] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNewTopic, setAddNewTopic] = useState(false);

    const [syllabusStructureNameSort, setSyllabusStructureNameSort] = useState(null);
    const [subjectSort, setSubjectSort] = useState(null);
    const [lessonNameSort, setLessonNameSort] = useState(null);
    const [topicNameSort, setTopicNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["topicMasterSyllabusStructureMasterDetails.syllabusStructureName", "subjectMasterDetails.subjectName", "lessonMasterDetails.lessonName", "topicName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getTopicList();
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const getApiUrl = () => {
        if (topicData.syllabusStructureMasterId !== '' && topicData.subjectMasterId !== '') {
            // Construct the API URL when syllabusData changes
            let apiUrl = '/get-topic-master-list?';

            if (topicData.syllabusStructureMasterId) {
                apiUrl += `syllabusStructureId=${topicData.syllabusStructureMasterId}&`;
            }

            if (topicData.subjectMasterId) {
                apiUrl += `subjectMasterId=${topicData.subjectMasterId}&`;
            }

            if (topicData.lessonMasterId) {
                apiUrl += `lessonId=${topicData.lessonMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            return apiUrl;
        }
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (topicData.syllabusStructureMasterId !== '' && topicData.subjectMasterId !== '') {
                // Construct the API URL when syllabusData changes
                // let apiUrl = '/get-topic-master-list?';

                // if (topicData.syllabusStructureMasterId) {
                //     apiUrl += `syllabusStructureId=${topicData.syllabusStructureMasterId}&`;
                // }

                // if (topicData.subjectMasterId) {
                //     apiUrl += `subjectMasterId=${topicData.subjectMasterId}&`;
                // }

                // if (topicData.lessonMasterId) {
                //     apiUrl += `lessonId=${topicData.lessonMasterId}&`;
                // }

                // apiUrl = apiUrl.replace(/&$/, '');


                setTopicList(await searchArray("A", getApiUrl(), searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        if (topicData.syllabusStructureMasterId !== '' && topicData.subjectMasterId !== '') {
            // Construct the API URL when syllabusData changes
            // let apiUrl = '/get-topic-master-list?';

            // if (topicData.syllabusStructureMasterId) {
            //     apiUrl += `syllabusStructureId=${topicData.syllabusStructureMasterId}&`;
            // }

            // if (topicData.subjectMasterId) {
            //     apiUrl += `subjectMasterId=${topicData.subjectMasterId}&`;
            // }

            // if (topicData.lessonMasterId) {
            //     apiUrl += `lessonId=${topicData.lessonMasterId}&`;
            // }

            // apiUrl = apiUrl.replace(/&$/, '');

            let apiUrl = getApiUrl();
            // Make the API call
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setTopicList(response.data.result);
                    // console.log('Data:', response.data);
                })
                .catch(error => {
                    setTopicList(error?.response?.data.result);
                    console.error('Error fetching data:', error);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    // Swal.fire(
                    //     { text: errorMsg }
                    // );
                });
        }
    }, [topicData, refresh]);

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(topicList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNewTopic])

    useEffect(() => {
        setTotalPages(Math.ceil(topicList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > topicList.length) {
            endIndex = topicList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(topicList.slice(startIndex, endIndex));
    }, [topicList, currPage, itemsPerPage]);

    const getTopicList = () => {
        if (topicData.syllabusStructureMasterId !== '' && topicData.subjectMasterId !== '') {
            let apiUrl = getApiUrl();
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setTopicList(response.data.result)
                    setAddNewTopic(!addNewTopic)

                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire({
                        text: errorMsg
                    })
                });
        }
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-syllabus-structure-master`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
                // console.log('Data:', response.data);
            })
            .catch(error => {
                // Handle any errors that occurred during the request
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            });
    }

    const handleInputChange = (e, index) => {
        setTopicData((prevData) => {
            if (e.target.name === 'topicName') {
                // Update the value at the specified index
                const updatedTopicName = [...prevData.topicName];
                updatedTopicName[index] = e.target.value;
                return {
                    ...prevData,
                    topicName: updatedTopicName,
                }
            } else {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value
                }
            }
        })
    }

    const handleAddTopic = () => {
        setTopicData((prevData) => ({
            ...prevData,
            topicName: [...prevData.topicName, ''],
        }));
    };

    const handleRemoveTopic = (index) => {
        setTopicData((prevData) => {
            const updatedTopicName = [...prevData.topicName];
            // Remove the element at the specified index
            updatedTopicName.splice(index, 1);
            return {
                ...prevData,
                topicName: updatedTopicName,
            }
        });
    }

    const handleSyllabusChange = (e) => {
        setTopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                subjectMasterId: '',
                lessonMasterId: ''
            }
        })


        const apiUrl2 = `/syllabus-structure-wise-subjects?id=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl2)
            .then(response => {
                setSubjectList(response.data.result)
                console.log('Data:', response.data);
            })
            .catch(error => {
                // Handle any errors that occurred during the request
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';

            });

    }

    const handleSubjectChange = (e) => {
        setTopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                lessonMasterId: ''
            }
        })
        const apiUrl = `/subject-wise-lesson?syllabusStructureMasterId=${topicData.syllabusStructureMasterId}&subjectMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                // Handle any errors that occurred during the request
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            });
    }


    //error

    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)

    const validateForm = () => {
        // Check if there are any errors in the error object
        const noErrors = Object.values(error).every((error) => error === '');

        // Check if all values in topicData are non-empty strings or non-empty arrays
        const allValuesValid = Object.entries(topicData).every(([key, value]) => {
            if (key === 'topicName' && Array.isArray(value)) {
                // Check if every element in topicName array is a non-empty string
                return value.every(topic => typeof topic === 'string' && topic.trim() !== '');
            } else {
                // Check if value is a non-empty string
                return typeof value === 'string' && value.trim() !== '';
            }
        });

        return noErrors && allValuesValid;
    };


    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(topicData)) {
                if (key === "topicName") {
                    for (const topic of topicData.topicName) {
                        if (topic == '' || topic.length == 0) {
                            setError((prevData) => ({
                                ...prevData,
                                topicName: 'This field is required.',
                            }));
                            break;
                        } else {
                            setError((prevData) => {
                                return {
                                    ...prevData,
                                    [key]: '',
                                }
                            });
                        }
                    }
                } else if (value == '' || value.length == 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [topicData])

    const addTopic = () => {
        const apiUrl = `/add-topic-master`;
        if (validateForm()) {
            setLoading(true)
            authorizedAxios && authorizedAxios.post(apiUrl, topicData)
                .then(response => {
                    getTopicList();
                    // setTopicList(response.data.result);

                    setTopicData((prevData) => {
                        return {
                            ...prevData,
                            topicName: [''],
                        }
                    })

                    setSaveId(response.data.result[0].id);

                    setSyllabusStructureNameSort(null);
                    setSubjectSort(null);
                    setLessonNameSort(null);
                    setTopicNameSort(null);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            for (const [key, value] of Object.entries(topicData)) {
                if (key === "topicName") {
                    for (const topic of topicData.topicName) {
                        if (topic == '' || topic.length == 0) {
                            setError((prevData) => ({
                                ...prevData,
                                topicName: 'This field is required.',
                            }));
                            break;
                        } else {
                            setError((prevData) => {
                                return {
                                    ...prevData,
                                    [key]: '',
                                }
                            });
                        }
                    }
                } else if (value == '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                }
                else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }

    }

    const deleteTopic = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-topic-master?id=${id}`;
            authorizedAxios && authorizedAxios.delete(apiUrl)
                .then(response => {
                    const page = deleteItem(currPage, itemsPerPage, topicList.length);
                    setRefresh(!refresh);
                    setCurrPage(page);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    const updateTopic = () => {
        setLoading(true);
        const apiUrl = `/edit-topic-master?id=${editId}`;
        authorizedAxios && authorizedAxios.put(apiUrl, topicData)
            .then(response => {
                getTopicList();
                setSaveId(response.data.result.id);
                setEditId(null);
                setTopicData((prevData) => {
                    return {
                        ...prevData,
                        topicName: [''],
                    }

                })
                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    const handleInputReset = () => {
        setTopicList([]);
        setEditId('');
        setTopicData(initialFormState);
        setSyllabusStructureNameSort(null);
        setSubjectSort(null);
        setLessonNameSort(null);
        setTopicNameSort(null);
    }

    useEffect(() => {
        if (syllabusStructureNameSort == true || syllabusStructureNameSort == false) {
            setSubjectSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
        }
    }, [syllabusStructureNameSort])

    useEffect(() => {
        if (subjectSort == true || subjectSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
        }
    }, [subjectSort])

    useEffect(() => {
        if (lessonNameSort == true || lessonNameSort == false) {
            setSyllabusStructureNameSort(null);
            setSubjectSort(null);
            setTopicNameSort(null);
        }
    }, [lessonNameSort])

    useEffect(() => {
        if (topicNameSort == true || topicNameSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setSubjectSort(null);
        }
    }, [topicNameSort])


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Topic </span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-hashtag"></i> Topic Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select class="form-select" aria-label="Default select example" name='syllabusStructureMasterId' onChange={handleSyllabusChange} value={topicData.syllabusStructureMasterId}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.syllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>

                                                    {error.syllabusStructureMasterId && <p style={{ color: 'red' }}>{error.syllabusStructureMasterId}</p>}

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select class="form-select" aria-label="Default select example" name='subjectMasterId' onChange={handleSubjectChange} value={topicData.subjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.subjectMasterDetails.id}>{syllabus.subjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.subjectMasterId && <p style={{ color: 'red' }}>{error.subjectMasterId}</p>}

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select class="form-select" aria-label="Default select example" name='lessonMasterId' onChange={handleInputChange} value={topicData.lessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.lessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.lessonMasterId && <p style={{ color: 'red' }}>{error.lessonMasterId}</p>}

                                                </div>

                                            </div>
                                            <div className="row">
                                                {topicData.topicName.map((topic, index) => (
                                                    <>
                                                        <div className="col-md-11">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Topic Name :</label>
                                                            <input type="text" className="form-control" id={`topicName${index}`} name='topicName' onChange={(e) => handleInputChange(e, index)} value={topic} />
                                                            {error.topicName && topic == "" && <p style={{ color: 'red' }}>{error.topicName}</p>}

                                                        </div>
                                                        {topicData.topicName.length > 1 && (
                                                            <div className="col-md-1 mt-4 mb-1" style={{ textAlign: 'right' }}>
                                                                <button className="btn btn-primary" type="button" style={{ marginTop: '14px' }} onClick={() => handleRemoveTopic(index)} ><i className="material-icons" style={{ fontSize: '20px' }}>delete</i></button>
                                                            </div>
                                                        )}
                                                    </>
                                                ))}
                                                {!editId && (
                                                    <div className="col-md-12 mt-4 mb-1">
                                                        <div className="col-auto">
                                                            <button className="btn btn-primary" type="button" style={{ width: '220px' }} onClick={handleAddTopic}>+ Add Another Topic Name</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>

                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addTopic}>Save</button>
                                                        }
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={handleInputReset}>Reset</button>

                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateTopic} disabled={!editId}>Update</button>)
                                                        }
                                                        {/* <button className="btn btn-outline-secondary" type="button">Close</button> */}
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>

                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Syllabus Structure Name
                                                                            <SortIcon sortState={syllabusStructureNameSort} setSortState={setSyllabusStructureNameSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"topicMasterSyllabusStructureMasterDetails.syllabusStructureName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject
                                                                            <SortIcon sortState={subjectSort} setSortState={setSubjectSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"subjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Lesson Name
                                                                            <SortIcon sortState={lessonNameSort} setSortState={setLessonNameSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"lessonMasterDetails.lessonName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Topic Name
                                                                            <SortIcon sortState={topicNameSort} setSortState={setTopicNameSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"topicName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((topic, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{topic.topicMasterSyllabusStructureMasterDetails.syllabusStructureName}</td>
                                                                                        <td>{topic.subjectMasterDetails?.subjectName}</td>
                                                                                        <td>{topic.lessonMasterDetails?.lessonName}</td>
                                                                                        <td>{topic.topicName}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setTopicData({
                                                                                                    lessonMasterId: topic.lessonMasterDetails?.id,
                                                                                                    topicName: [topic.topicName],
                                                                                                    subjectMasterId: topic.subjectMasterDetails.id,
                                                                                                    syllabusStructureMasterId: topic.topicMasterSyllabusStructureMasterDetails.id
                                                                                                });
                                                                                                setEditId(topic.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === topic.id} onClick={() => deleteTopic(topic.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Topic Available</th>

                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>

                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={topicList.length} />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default TopicMaster;